"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAG_OWNER = void 0;
exports.TAG_OWNER = {
    LANDING: 'LANDING',
    PRODUCT: 'PRODUCT',
    CAMPAIGN: 'CAMPAIGN',
    ORDER_HOLD_REASON: 'ORDER_HOLD_REASON'
};
//# sourceMappingURL=tagOwner.js.map